/*       */

import React from 'react';
import styled from 'styled-components';

const FullWidthStyled = styled.div`
    width: 100%;
`;

const Group = React.memo(({ children, className, ...divProps }) => {
    const combinedClassName = className ? `group ${className}` : 'group';
    return <FullWidthStyled className={combinedClassName} {...divProps}>{children}</FullWidthStyled>;
});

export default Group;
